import { checkTransactionLoop } from '../../utils/common';
import { BuildModuleParamsType } from 'types/api-internal';
import {
  SugarMoneyApiPayoutProgressResponseType,
  SugarMoneyApiRequestPayoutResponseType,
  SugarMoneyApiSubmitPayoutRequestType,
  SugarMoneyApiSubmitPayoutResponseType,
  SugarMoneyTransactionStatusResponseType,
} from '../../types/common';
import {
  SugarMoneyApiCreateGameRequestType,
  SugarMoneyApiCreateGameResponseType,
  SugarMoneyApiCurrentGameResponseType,
  SugarMoneyApiGameHistoryRequestType,
  SugarMoneyApiGameHistoryResponseType,
  SugarMoneyApiUpdateGameRequestType,
  SugarMoneyApiUpdateGameResponseType,
} from '../../types/game';

export const gameModule = ({ makeApiRequest, checkTransactionStatus }: BuildModuleParamsType) => ({
  current: async () =>
    makeApiRequest<SugarMoneyApiCurrentGameResponseType>({
      endpoint: 'game/current',
      options: { method: 'get' },
    }),
  create: ({ tickets }: SugarMoneyApiCreateGameRequestType) =>
    makeApiRequest<SugarMoneyApiCreateGameResponseType>({
      endpoint: 'game/create',
      data: { tickets },
      options: { method: 'post' },
    }),
  update: ({ gameId, index }: SugarMoneyApiUpdateGameRequestType) =>
    makeApiRequest<SugarMoneyApiUpdateGameResponseType>({
      endpoint: 'game/update',
      data: { gameId, index },
      options: { method: 'post' },
    }),
  history: async ({ data }: { data: SugarMoneyApiGameHistoryRequestType }) =>
    makeApiRequest<SugarMoneyApiGameHistoryResponseType[]>({
      endpoint: 'game/history',
      searchParams: data,
      options: { method: 'get' },
    }),
  payout: {
    inProgress: async () =>
      makeApiRequest<SugarMoneyApiPayoutProgressResponseType>({
        endpoint: 'game/payout/in-progress',
        options: { method: 'get' },
      }),
    request: () =>
      makeApiRequest<SugarMoneyApiRequestPayoutResponseType>({
        endpoint: 'game/payout/request',
        options: { method: 'post' },
      }),
    submit: async (data: SugarMoneyApiSubmitPayoutRequestType) => {
      const response = await makeApiRequest<SugarMoneyTransactionStatusResponseType>({
        endpoint: 'game/payout/submit',
        data,
        options: { method: 'post' },
      });

      return checkTransactionLoop({
        signature: response.signature,
        checkTransactionStatus,
      });
    },
  },
});
